
export class ActionConstants {
    public static readonly workspaceRead = 'Microsoft.Synapse/workspaces/read';
    public static readonly workspaceWrite = 'Microsoft.Synapse/workspaces/write';

    public static readonly roleAssignmentsWrite = 'Microsoft.Synapse/workspaces/roleAssignments/write';
    public static readonly roleAssignmentsDelete = 'Microsoft.Synapse/workspaces/roleAssignments/delete';

    public static readonly artifactsRead = 'Microsoft.Synapse/workspaces/artifacts/read';
    public static readonly integrationRuntimesRead = 'Microsoft.Synapse/workspaces/integrationruntimes/read';

    public static readonly dataFlowsWrite = 'Microsoft.Synapse/workspaces/dataFlows/write';
    public static readonly dataMappersWrite = 'Microsoft.Synapse/workspaces/dataMappers/write';
    public static readonly pipelinesWrite = 'Microsoft.Synapse/workspaces/pipelines/write';
    public static readonly triggersWrite = 'Microsoft.Synapse/workspaces/triggers/write';
    public static readonly datasetsWrite = 'Microsoft.Synapse/workspaces/datasets/write';
    public static readonly linkedServicesWrite = 'Microsoft.Synapse/workspaces/linkedServices/write';
    public static readonly credentialsWrite = 'Microsoft.Synapse/workspaces/credentials/write';
    public static readonly notebooksWrite = 'Microsoft.Synapse/workspaces/notebooks/write';
    public static readonly scopeJobDefinitionsWrite = 'Microsoft.Synapse/workspaces/scopeJobDefinitions/write';
    public static readonly sparkJobDefinitionsWrite = 'Microsoft.Synapse/workspaces/sparkJobDefinitions/write';
    public static readonly sparkConfigurationsWrite = 'Microsoft.Synapse/workspaces/sparkConfigurations/write';
    public static readonly sqlScriptsWrite = 'Microsoft.Synapse/workspaces/sqlScripts/write';
    public static readonly kqlScriptsWrite = 'Microsoft.Synapse/workspaces/kqlScripts/write';
    public static readonly integrationRuntimesWrite = 'Microsoft.Synapse/workspaces/integrationruntimes/write';

    public static readonly dataFlowsDelete = 'Microsoft.Synapse/workspaces/dataFlows/delete';
    public static readonly dataMappersDelete = 'Microsoft.Synapse/workspaces/dataMappers/delete';
    public static readonly pipelinesDelete = 'Microsoft.Synapse/workspaces/pipelines/delete';
    public static readonly triggersDelete = 'Microsoft.Synapse/workspaces/triggers/delete';
    public static readonly datasetsDelete = 'Microsoft.Synapse/workspaces/datasets/delete';
    public static readonly linkedServicesDelete = 'Microsoft.Synapse/workspaces/linkedServices/delete';
    public static readonly credentialsDelete = 'Microsoft.Synapse/workspaces/credentials/delete';
    public static readonly notebooksDelete = 'Microsoft.Synapse/workspaces/notebooks/delete';
    public static readonly scopeJobDefinitionsDelete = 'Microsoft.Synapse/workspaces/scopeJobDefinitions/delete';
    public static readonly sparkJobDefinitionsDelete = 'Microsoft.Synapse/workspaces/sparkJobDefinitions/delete';
    public static readonly sparkConfigurationsDelete = 'Microsoft.Synapse/workspaces/sparkConfigurations/delete';
    public static readonly sqlScriptsDelete = 'Microsoft.Synapse/workspaces/sqlScripts/delete';
    public static readonly kqlScriptsDelete = 'Microsoft.Synapse/workspaces/kqlScripts/delete';
    public static readonly integrationRuntimesDelete = 'Microsoft.Synapse/workspaces/integrationruntimes/delete';

    public static readonly credentialUseSecret = 'Microsoft.Synapse/workspaces/credentials/useSecret/action';

    public static readonly managedPrivateEndpointsWrite = 'Microsoft.Synapse/workspaces/managedPrivateEndpoints/write';
    public static readonly managedPrivateEndpointsDelete = 'Microsoft.Synapse/workspaces/managedPrivateEndpoints/delete';

    public static readonly pipelineViewLogs = 'Microsoft.Synapse/workspaces/pipelines/viewOutputs/action';

    public static readonly bigDataPoolViewLogs = 'Microsoft.Synapse/workspaces/bigDataPools/viewLogs/action';
    public static readonly bigDataPoolUseCompute = 'Microsoft.Synapse/workspaces/bigDataPools/useCompute/action';

    public static readonly linkConnectionsWrite = 'Microsoft.Synapse/workspaces/linkConnections/write';
    public static readonly linkConnectionsRead = 'Microsoft.Synapse/workspaces/linkConnections/read';
    public static readonly linkConnectionsDelete = 'Microsoft.Synapse/workspaces/linkConnections/delete';
    public static readonly linkConnectionsOperation = 'Microsoft.Synapse/workspaces/linkConnections/useCompute/action'; // Start/Stop/Pause
}
